import React from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import { CustomizedTooltip } from 'components/common';

export const CreateRiskRegisterButton = () => {
    const { pathname } = useLocation();
    const history = useHistory();

    const handleAddTask = () => {
        history.push(`${pathname}/create`);
    };

    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Top}
            tooltipContent={`Add risk`}
            triggerElement={
                <Button
                    startIcon={<MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />}
                    variant={'primary'}
                    onClick={handleAddTask}
                >
                    Add new risk
                </Button>
            }
        />
    );
};
